import { createContext, useContext, useState } from "react";

const SocketContext = createContext(null);

export const SocketConnectionProvider = ({children}) => {
    const [socketConnection, setSocketConnection] = useState(null);

    const setSocketConnectionData = (connection) => {
        setSocketConnection(connection);
    }

    return (
        <SocketContext.Provider value={{socketConnection, setSocketConnectionData}}>{children}</SocketContext.Provider>
    );
}

export const useSocket = () => useContext(SocketContext);